import React from "react";
import { Typography, Box, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { useAppContext } from "../../context/AppContext";
import styles from "./DemoMode.module.scss";
import strings from "../../strings";

const DemoModeBanner = () => {
  const st = strings.DEMO_MODE;
  const { isDemoMode, setDemoMode, demoModeFeatureActive } = useAppContext();

  if (!isDemoMode || !demoModeFeatureActive ) return null;

  return (
    <>
      <Box
        className={styles.bannerContainer}
      >
        <Typography variant="body2">
          {st.YOU_ARE_USING_DEMO_MODE + " " + st.NO_REAL_DATA_IS_BEING_DISPLAYED}
        </Typography>
        <IconButton onClick={()=>{setDemoMode(!isDemoMode)}} className={styles.bannerCloseIcon} size="small" >
          <CloseIcon />  <Typography variant="body2">
            {st.EXIT_DEMO_MODE}
          </Typography>
        </IconButton>
      </Box>
      <div className={styles.invisibleDiv} />
    </>
  );
};

export default DemoModeBanner;
